//src/app/features/services/addService/index.tsx
import MainWizardSteps from 'app/features/questionnaires/components/MainWizardSteps';
import StepWizard from 'react-step-wizard';
import AddServicesStepOne from './step-one';
import AddServicesStepTwo from './step-two';

const AddServies = () => {
  const shouldRedirectToCheckout = JSON.parse(
    sessionStorage.getItem('shouldRedirectToCheckout') || 'false',
  );
  const initialStep = shouldRedirectToCheckout ? 2 : 1;
  sessionStorage.setItem('shouldRedirectToCheckout', JSON.stringify(false));

  const steps = ['Choose your Service', 'Payment and Checkout'];
  return (
    <div className="p-4">
      <StepWizard
        isLazyMount
        className="wizard z-0"
        initialStep={initialStep}
        nav={<MainWizardSteps steps={steps} />}
      >
        <AddServicesStepOne />
        <AddServicesStepTwo />
      </StepWizard>
    </div>
  );
};

export default AddServies;
